function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback, useContext, useMemo } from 'react';
import styles from '../RecordCompareArrayGroup.module.scss';
import CompareContext from '../RecordCompareContext';
import { injectIntl } from 'react-intl';
import { getColumnId, getRowId } from '../../../util/recordCompareAria';
import CheckboxInput from '../../../../Inputs/CheckboxInput/CheckboxInput';
import RecordCompareStateContext from '../../../RecordCompareStateContext';
import ThemeContext from '../../../../ThemeContext';
function CheckboxField(_ref) {
  var layoutRowId = _ref.layoutRowId,
    recordIndex = _ref.recordIndex,
    fieldIndex = _ref.fieldIndex,
    data = _ref.data,
    intl = _ref.intl;
  var _useContext = useContext(CompareContext),
    records = _useContext.records,
    mergeRecord = _useContext.mergeRecord;
  var _useContext2 = useContext(RecordCompareStateContext),
    mergeSelections = _useContext2.mergeSelections,
    selections = _useContext2.selections,
    isMergeEnabled = _useContext2.isMergeEnabled;
  var uiSchema = mergeRecord.uiSchema;
  var recordId = records[recordIndex].recordId;
  var key = "r".concat(fieldIndex, "-c").concat(recordIndex);
  var checked = !!(selections[layoutRowId] && selections[layoutRowId][key]);
  var disabled = uiSchema[layoutRowId]['ui:disabled'];
  var triggerData = useMemo(function () {
    return records[recordIndex] && records[recordIndex].triggers && records[recordIndex].triggers.find(function (trigger) {
      return !!trigger.data[data.faculty_name];
    });
  }, [records, recordIndex, data]);
  var handleChange = useCallback(function (e) {
    mergeSelections(_defineProperty({}, layoutRowId, Object.assign({}, selections[layoutRowId], _defineProperty({}, key, e.target.checked))));
  }, [selections, layoutRowId, key, mergeSelections]);
  var cardLabel = useMemo(function () {
    if (data) {
      var display = '';
      if ((data.fname === undefined || data.fname === null || data.fname === '') && triggerData && triggerData.data) {
        display = triggerData.data[data.faculty_name].filter(function (name) {
          return name !== '';
        }).join(' ');
      } else {
        display = "".concat(data.fname || '', " ").concat(data.lname || '').trim();
      }
      if (display.length > 0) {
        return display;
      }
    }
    return intl.formatMessage({
      id: '@dm/components.record-compare.labels.none'
    });
  }, [data, intl, triggerData]);
  if (!isMergeEnabled) {
    return /*#__PURE__*/React.createElement("span", {
      className: styles['read-only-checkbox']
    }, cardLabel);
  }
  return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: 'ripple'
  }, /*#__PURE__*/React.createElement(CheckboxInput, {
    "aria-describedby": "".concat(getColumnId(recordIndex), " ").concat(getRowId(layoutRowId)),
    checked: checked,
    disabled: false,
    readonly: disabled && !checked,
    id: "".concat(layoutRowId, "-").concat(recordId, "-").concat(recordIndex, "-").concat(fieldIndex),
    label: cardLabel,
    labelEscape: escape,
    name: "".concat(layoutRowId),
    onChange: handleChange,
    size: "small"
  }));
}
export default injectIntl(CheckboxField);